var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.service
        ? _c("h1", { staticClass: "title" }, [
            _vm._v("\n    " + _vm._s(_vm.service.label) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.items
        ? _c("CategoryList", { attrs: { items: _vm.items } })
        : !_vm.isLoading
        ? _c("div", [_vm._v(_vm._s(_vm.$t('msg["Data is empty"]')))])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }